export const FEATURE_FLAGS = {
    StrawberryHarvestTools: "STRAWBERRY_HARVEST_TOOLS",
    NoteIntersections: "NOTE_INTERSECTIONS",
    BetaCalendar: "BETA_CALENDAR",
};
